import ONBOARDING_METALENS_TUTORIAL_GIF from "../../../assets/Revv_Metalens_Revised_GIF.gif";
import ONBOARDING_ESIGN_TUTORIAL_GIF from "../../../assets/esign.gif";
import ONBOARDING_PAYMENT_TUTORIAL_GIF from "../../../assets/payment.gif";

export const onBoardingContent = {
  metalens: {
    caption:
      "Hey there! This is METALENS, a machine-learning enabled, powerful document analyzer.",
    description:
      "Metalens identifies and extracts data in the document such as names, dates, locations, amounts, and more. Quickly review this data or download data in standard JSON format for use by other business apps",
    buttonText: "Try Metalens",
    gif: ONBOARDING_METALENS_TUTORIAL_GIF,
    type: "metalens",
    modalType: "metalens",
    hasToggle: true,
  },
  esignature: {
    caption:
      "Hey there! This is a Signature block. Drag and drop signature blocks in your document, add signer details, and click eSign to initiate the process.",
    description:
      "Signers get an email with the document link requesting their signature. You can add the same signer in multiple blocks, choose how you want the signature to be captured (draw or initials) and even enable SMS based OTP for signer authentication.",
    buttonText: "Got it",
    gif: ONBOARDING_ESIGN_TUTORIAL_GIF,
    type: "esign",
    modalType: "esignature",
  },
  stripe: {
    caption:
      "Hey there! Collect payments from your customers. Add this payment button and share documents with your customers to collect payments instantly (enabled via Stripe).",
    description:
      "Recipients, with whom you share the document, can click the payment button to pay you. You can add multiple payment buttons. To send documents, click 'Send' and use the 'Send to someone' option or share it via a 'Magic link'. All payments are managed by Stripe directly, with no extra charges from Revv. If you face any payment issues please contact Stripe.",
    buttonText: "Got it",
    gif: ONBOARDING_PAYMENT_TUTORIAL_GIF,
    type: "payment",
    modalType: "stripe",
  },
};

export const onBoardingTypes = ["esignature", "businessproposal", "quotes"];
export const onBoardingModals = {
  esignature: "esignature",
  businessproposal: ["metalens", "stripe"],
  quotes: "stripe",
};



// WEBPACK FOOTER //
// ./src/components/DocumentV2/OnboardModal/options.js